import Service, { service } from "@ember/service";
import type Features from "ember-feature-flags";
import type SemeiaSessionService from "./session";

export type Issuer = "pro-sante-connect" | "aphp-medic" | "hcl-medic";

export default abstract class OpenIdConnectService extends Service {
  @service declare features: Features;
  @service declare session: SemeiaSessionService;

  abstract featureFlag: string;
  abstract imageUrl: string;
  abstract issuer: Issuer;
  abstract label: string;
  declare route: string;

  get isEnabled(): boolean {
    return this.features.isEnabled(this.featureFlag);
  }
}
